<template>
	<div class="home">
		<div class="title">
			{{
				LargeScreenData && LargeScreenData.AreaName
					? LargeScreenData.AreaName
					: ''
			}}义务教育学校作业管理公示栏
		</div>
		<div class="school-info">
			<div>
				{{
					LargeScreenData && LargeScreenData.SchoolName
						? LargeScreenData.SchoolName
						: ''
				}}
			</div>
			<div>
				{{
					LargeScreenData && LargeScreenData.DeptName
						? LargeScreenData.DeptName
						: ''
				}}
			</div>
			<div>日期：{{ formateDate('YYYY年mm月dd日') }}</div>
		</div>
		<div class="table">
			<div class="table-head">
				<div class="line1">作业类型</div>
				<div class="line2">学科</div>
				<div class="line3">时长（分钟）</div>
				<div class="line4">总时长（分钟）</div>
				<div class="line5">备注</div>
			</div>
			<div class="table-body" v-if="workList">
				<div class="table-item" v-for="(item, index) in workList" :key="index">
					<div class="line1 type">{{ item.name }}</div>
					<div class="info-box">
						<div class="info" v-for="(ite, idx) in item.list" :key="idx">
							<div class="line2">{{ ite.Subject }}</div>
							<div class="line3">{{ ite.Duration }}</div>
							<div class="line4">{{ ite.TotalDuration }}</div>
							<div class="line5">{{ ite.Remake }}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="table-body" v-else>
				<div class="table-item">
					<div class="line1 type"></div>
					<div class="info-box">
						<div class="info">
							<div class="line2"></div>
							<div class="line3"></div>
							<div class="line4"></div>
							<div class="line5"></div>
						</div>
						<div class="info">
							<div class="line2"></div>
							<div class="line3"></div>
							<div class="line4"></div>
							<div class="line5"></div>
						</div>
						<div class="info">
							<div class="line2"></div>
							<div class="line3"></div>
							<div class="line4"></div>
							<div class="line5"></div>
						</div>
						<div class="info">
							<div class="line2"></div>
							<div class="line3"></div>
							<div class="line4"></div>
							<div class="line5"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="school-info class-info">
			<div>
				班主任：{{
					LargeScreenData && LargeScreenData.ClassLeader
						? LargeScreenData.ClassLeader
						: ''
				}}
			</div>
			<div>
				年级作业负责人：{{
					LargeScreenData && LargeScreenData.GradeLeader
						? LargeScreenData.GradeLeader
						: ''
				}}
			</div>
		</div>
		<div class="gap"></div>

		<div class="tip">
			<div class="title">管理办法</div>
			<div class="conten">
				<p>国家政策：</p>
				<p>
					1.作业总量要求：一、二年级不得布置书面家庭作业；三到六年级学生每天书面作业完成时间不得超过60分钟；初中学生每天书面作业完成时间不得超过90分钟；85%的小学生在校内基本完成书面作业；在周末、寒暑假、法定节假日严格控制书面作业时间；小学生应在21点20前睡觉，初中生应在22点前睡觉，没有完成作业也要按时睡觉：
				</p>
				<p>
					2.作业质量要求：作业设计应符合学习规律，体现素质教育导向；学校实施作业统筹、公示制度；作业难度不得超过国家课程标准要求。充分考量后15%学生的完成能力；
				</p>
				<p>
					3.作业形式要求：根据学段、学科特点及学生实际需要和完成能力合理布置作业，多种作业类型相结合；切实避免机械、无效训练，严禁布置重复性、惩罚性作业；
				</p>
				<p>
					4.作业改评要求：教师要充分利用课堂教学时间和课后服务时间加强学生作业指导，不得利用课后服务时间讲新课；严禁给家长布置或变相布置作业，严禁要求家长检查、批改作业。
				</p>
			</div>
		</div>
		<div class="school-info class-info">
			<div>
				学校责任人：{{
					LargeScreenData && LargeScreenData.SchoolLeader
						? LargeScreenData.SchoolLeader
						: ''
				}}
			</div>
			<div>
				学校监督电话：{{
					LargeScreenData && LargeScreenData.SchoolPhone
						? LargeScreenData.SchoolPhone
						: ''
				}}
			</div>
		</div>
		<div class="gap"></div>
		<div class="school-info class-info">
			<div>
				区级监督电话：{{
					LargeScreenData && LargeScreenData.AreaPhone
						? LargeScreenData.AreaPhone
						: ''
				}}
			</div>
			<div>
				市级监督电话：{{
					LargeScreenData && LargeScreenData.CityPhone
						? LargeScreenData.CityPhone
						: ''
				}}
			</div>
			<div>
				省级监督电话：{{
					LargeScreenData && LargeScreenData.ProvincePhone
						? LargeScreenData.ProvincePhone
						: ''
				}}
			</div>
		</div>
	</div>
</template>

<script>

import { getClassWorkSummary } from '../api/modules/misc';

export default {
	name: 'Home',
	components: {},
	data() {
		return {
			deptId: null,
			LargeScreenData: null,
			workList: null,
		}
	},
	mounted() {
		this.deptId = this.$route.query.id
		if (this.deptId) {
			this.init(this.deptId)
		}
	},
	methods: {
		init(deptId) {

			var params = { classId: deptId };
			getClassWorkSummary(params).then(data => {
				if (data.data.success) {
					console.log(data.data.response);
					this.LargeScreenData = data.data.response;
					console.log(this.LargeScreenData);

					let temp = {}
					this.LargeScreenData.WorkList.forEach((item) => {
						let tempt = temp[`${item.Type}`]
							? { ...temp[`${item.Type}`] }
							: {
								name: item.Type,
								list: [],
							}
						tempt.list.push(item)
						temp[`${item.Type}`] = tempt
					})
					this.workList = temp

				} else {
					this.LargeScreenData = null;
				}
			});

			// this.LargeScreenData = {
			// 	AreaName: "区域名称",
			// 	SchoolName: "学校名称",
			// 	DeptName: "班级名称",
			// 	ClassLeader: "班主任",
			// 	GradeLeader: "年级负责人",
			// 	SchoolLeader: "学校责任人",
			// 	SchoolPhone: "xxxxxxxxx",
			// 	AreaPhone: "xxxxxxxxx",
			// 	CityPhone: "xxxxxxxx",
			// 	ProvincePhone: "xxxxxxxx",
			// 	WorkList: [
			// 		{
			// 			Type: "书面作业",
			// 			Subject: "英语",
			// 			Duration: 60,
			// 			TotalDuration: 100,
			// 			Remake: ""
			// 		},
			// 		{
			// 			Type: "书面作业",
			// 			Subject: "语文",
			// 			Duration: 60,
			// 			TotalDuration: 100,
			// 			Remake: ""
			// 		},
			// 		{
			// 			Type: "书面作业",
			// 			Subject: "语文",
			// 			Duration: 60,
			// 			TotalDuration: 100,
			// 			Remake: ""
			// 		},
			// 		{
			// 			Type: "口头作业",
			// 			Subject: "英语",
			// 			Duration: 60,
			// 			TotalDuration: 100,
			// 			Remake: ""
			// 		}
			// 	]
			// }
		},
		formateDate(fmt = 'YYYY-mm-dd', date = '') {
			if (!date) {
				date = new Date()
			}

			try {
				if (typeof date != 'object') {
					date = new Date(date.replace(/-/g, '/'))
				}
			} catch (error) {
				date = new Date()
			}

			let ret
			let weak = (function (date) {
				let days = date.getDay()
				let weekArrTxt = [
					'星期天',
					'星期一',
					'星期二',
					'星期三',
					'星期四',
					'星期五',
					'星期六',
				]
				let weekArrTxt2 = [
					'周日',
					'周一',
					'周二',
					'周三',
					'周四',
					'周五',
					'周六',
				]
				return [weekArrTxt[days], weekArrTxt2[days]]
			})(date)
			const opt = {
				'Y+': date.getFullYear().toString(), // 年
				'm+': (date.getMonth() + 1).toString(), // 月
				'd+': date.getDate().toString(), // 日
				'H+': date.getHours().toString(), // 时
				'M+': date.getMinutes().toString(), // 分
				'S+': date.getSeconds().toString(), // 秒
				// 有其他格式化字符需求可以继续添加，必须转化成字符串
				'W+': weak[0],
				'w+': weak[1],
			}
			for (let k in opt) {
				ret = new RegExp('(' + k + ')').exec(fmt)
				if (ret) {
					fmt = fmt.replace(
						ret[1],
						ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
					)
				}
			}
			return fmt
		},
	},
}
</script>

<style>
* {
	box-sizing: border-box;
	margin: 0;
	padding: 0;
}

.home {
	width: 100%;
	font-size: 1vw;
	padding: 5px;
}

.home .title {
	font-size: 1.8vw;
	font-weight: bold;
	text-align: center;
	padding: 0.15vw;
}

.home .table {
	text-align: center;
}

.home .table .line1 {
	width: 10%;
}

.home .table .line2 {
	width: 40%;
}

.home .table .line3 {
	width: 10%;
}

.home .table .line4 {
	width: 10%;
}

.home .table .line5 {
	width: 30%;
}

.home .table .table-head {
	display: flex;
	color: white;
	font-weight: bold;
	padding: 0.6vw;
	background: #4472c4;
	margin-bottom: 0.3vw;
}

.home .table .table-body {
	width: 100%;
}

.home .table .table-body .table-item {
	width: 100%;
	display: flex;
	margin-bottom: 0.15vw;
}

.home .table .table-body .table-item .type {
	display: flex;
	justify-content: center;
	align-items: center;
	background: #cfd5ea;
	border-right: 0.15vw solid white;
}

.home .table .table-body .table-item .info-box {
	flex: 1;
}

.home .table .table-body .table-item .info-box .info {
	display: flex;
	margin-bottom: 0.15vw;
	background: #e9ebf5;
}

.home .table .table-body .table-item .info-box .info .line1 {
	width: calc(100% / 0.9 * 0.1);
}

.home .table .table-body .table-item .info-box .info .line2 {
	width: calc(100% / 0.9 * 0.4);
}

.home .table .table-body .table-item .info-box .info .line3 {
	width: calc(100% / 0.9 * 0.1);
}

.home .table .table-body .table-item .info-box .info .line4 {
	width: calc(100% / 0.9 * 0.1);
}

.home .table .table-body .table-item .info-box .info .line5 {
	width: calc(100% / 0.9 * 0.3);
}

.home .table .table-body .table-item .info-box .info div {
	min-height: 2.2vw;
	padding: 0.5vw;
	border-right: 0.15vw solid white;
}

.home .table .table-body .table-item .info-box .info div:last-child {
	border: none;
}

.home .table .table-body .table-item .info-box .info:nth-child(odd) {
	background: #cfd5ea;
}

.home .table .table-body .table-item .info-box .info:last-child {
	margin-bottom: 0;
}

.home .table .table-body .table-item:last-child {
	margin-bottom: 0;
}

.home .school-info {
	display: flex;
	justify-content: space-between;
	padding: 1vw 1vw;
}

.home .class-info {
	font-weight: bold;
}

.home .tip .title {
	font-size: 1.2vw;
}

.home .tip .conten {
	padding: 10px;
	margin: 0 auto;
	border: 2px solid #4472c4;
}

.home .tip .conten p {
	margin-bottom: 0.3vw;
}

.home .gap {
	width: 100%;
	height: 3px;
	background: #4472c4;
}
</style>
